import { API_CORE_URL, API_WEBCHAT_URL } from '../../../constants/env';

export function getDeploymentLibraryScript() {
  return `<script src="${API_WEBCHAT_URL}"></script>`;
}
/**
 * Returns the snippet to embed the webchat in a website.
 *
 * @param {Object} options
 * @param {string} options.deploymentId The bot's deployment id to connect to the webchat with (required)
 * @returns {string} snippet
 */
export function getDeploymentSnippet({ deploymentId }) {
  return `
  <div id="botDiv"></div>
  <script> 
    window.HBFWebchat.init( 
      {
        "deploymentId":"${deploymentId}",
        "apiUrl":"${API_CORE_URL}"
      }
    );
  </script>`;
}
